import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type {
  CustomDimensions,
  ECommerce4Transaction,
} from "../integration/frontend-tracking-agent";

export interface ECommerceTransaction {
  id: string; // booking id or shopping id
  affiliation: string;
  revenue: number;
  tax: number;
  shipping: number;
  coupon?: string;
  totalAmount: number;
}

export interface ECommerceItem extends CustomDimensions {
  name: string;
  id: string;
  category: string;
  price: number;
  quantity: number;
  coupon?: string;
  variant?: string;
  brand?: string;
}

export interface TrackECommerceArg {
  transaction?: ECommerceTransaction;
  products?: Array<ECommerceItem>;
}
export interface ECommerceTrackingClient {
  trackEvent: (arg: TrackECommerceArg | ECommerce4Transaction) => Promise<void>;
}

interface ECommerceTrackingProviderProps {
  eCommerceTrackingClient: ECommerceTrackingClient;
  children: ReactNode;
}

const eCommerceTrackingContext = createContext<ECommerceTrackingClient>({
  trackEvent: () => Promise.resolve(),
});

export const useECommerceTracking = () => useContext(eCommerceTrackingContext);

export const ECommerceTrackingProvider = ({
  eCommerceTrackingClient,
  children,
}: ECommerceTrackingProviderProps) => (
  <eCommerceTrackingContext.Provider value={eCommerceTrackingClient}>
    {children}
  </eCommerceTrackingContext.Provider>
);
